// extracted by mini-css-extract-plugin
var _1 = "NotificationPopOver-module__header--cF_lO";
var _2 = "NotificationPopOver-module__markAll--MUkKf";
var _3 = "NotificationPopOver-module__title--HCcfd";
export { _1 as "header", _2 as "markAll", _3 as "title" }
